import React from 'react';
import PropTypes from 'prop-types';
import SelectFieldType from './fieldTypes/SelectFieldType';
import DateFieldType from './fieldTypes/DateFieldType';
import CheckBoxFieldType from './fieldTypes/CheckBoxFieldType';
import LanguageFieldType from './fieldTypes/LanguageFieldType';
import TextFieldType from './fieldTypes/TextFieldType';
import LocationFieldType from './fieldTypes/LocationFieldType';

const components = {
  select: SelectFieldType,
  date: DateFieldType,
  checkbox: CheckBoxFieldType,
  languageField: LanguageFieldType,
  text: TextFieldType,
  textArea: TextFieldType,
  custom: () => <div />,
  fieldArray: () => <div />,
  toggleButton: () => <div />,
  locationField: LocationFieldType,
  customTitle: () => <div />,
  barcodeField: () => <div />,
  instanceField: () => <div />,
};

function FieldTypeSelector({ fieldName, fieldData }) {
  const FieldComponent = components[fieldData.type];

  return <FieldComponent fieldData={fieldData} fieldName={fieldName} />;
}

FieldTypeSelector.propTypes = {
  fieldName: PropTypes.string,
  fieldData: PropTypes.object,
};

export default FieldTypeSelector;
